import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import ParentContentCard from '../common/ParentContentCard';
import CustomLoader from '../common/CustomLoader';
import { ErrorMessage, Field, Formik, Form } from 'formik';
import { getFieldDataTypeValueSupabase } from './common/common_utils';
import CustomSelect from '../home/collections/CustomSelect';
import { dropdownsForSupabase } from '../../common/utils/data_source-util';
import FormFieldWithLabel from '../common/FormFieldWithLabel';
import CustomRadio from '../../common/ui/CustomRadio';
import AlertMessageBox from '../../common/ui/AlertMessageBox';
import { checkDataSourcePermission } from '../../common/utils/permissions';
import PermissionDenied from '../../common/PermissionDenied';
export class SupabaseUpdateCollection extends Component {
  static propTypes = {
    dataConnector: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  state = {
    selectedCollectionIndex: 0,
    fieldDatatypes: [],
    supaBaseData: {},
  };

  async componentDidMount() {
    const { projectId, version, dbUuid, collectionIdx } = this.props.match.params;
    const { actions } = this.props;
    if (collectionIdx) {
      this.setState({ selectedCollectionIndex: collectionIdx });
    }
    await actions.getSupabaseExternalDb({ version, projectId, dbUuid });
    const { supabaseStoredData } = this.props.dataConnector;
    if (supabaseStoredData) {
      this.setState({ supaBaseData: supabaseStoredData });
    }
  }

  handleSave = async (values, selectedPrimaryKey) => {
    const { selectedCollectionIndex, fieldDatatypes, supaBaseData } = this.state;
    const { actions, match, history } = this.props;
    const { completeData, setting, name } = supaBaseData;

    const newArray = completeData ? completeData.tables : [];
    const selectedData = newArray[selectedCollectionIndex];
    const fieldData = selectedData.fields;
    const result = {};
    Object.keys(fieldData).map((fieldName, index) => {
      result[fieldName] = fieldDatatypes[fieldName]
        ? fieldDatatypes[fieldName].value
        : fieldData[fieldName];
    });
    const { projectId, dbUuid, version } = match.params;
    const data = {
      version,
      collectionNames: selectedData.name,
      collectionTitle: values.collectionTitle,
      orgCollectionName: selectedData.name,
      willPersist: false,
      fields: result,
      projectId,
      databaseUrl: completeData && completeData['database'],
      setting,
      externalDatabaseId: dbUuid,
      name,
      selectedPrimaryKey,
    };
    await actions.supabaseUpdateCollection(data);
    await actions.updateSupabaseExternalDb({
      projectId,
      collectionTitle: values.collectionTitle,
      externalDbUuid: dbUuid,
      result,
      version,
      tableIndex: selectedCollectionIndex,
    });
    history.push(`/data-connector/${version}/v/${projectId}/supabase-edit/${dbUuid}`);
  };
  handleFieldChange = (fieldName, selectedValue) => {
    const updatedResult = { ...this.state.fieldDatatypes };
    updatedResult[fieldName[0]] = selectedValue;
    this.setState({ fieldDatatypes: updatedResult });
  };
  handleCancel = () => {
    const { projectId, dbUuid, version } = this.props.match.params;
    this.props.history.push(`/data-connector/${version}/v/${projectId}/supabase-edit/${dbUuid}`);
  };
  showAlertMessage = () => {
    return (
      <AlertMessageBox
        type="info"
        text={`Note: If no primary key is selected below, the system will default to using the 
<strong>'id'</strong> field as the primary key for External APIs.`}
      />
    );
  };

  render() {
    const isAllowed = checkDataSourcePermission();
    if (!isAllowed) {
      return (
        <CommonPageComponent>
          <PermissionDenied message="Data Source" />;
        </CommonPageComponent>
      );
    }
    const { supaBaseData, selectedCollectionIndex } = this.state;
    const { getSupabaseExternalDbPending, createCollectionfromSupabasePending } =
      this.props.dataConnector;
    const { completeData } = supaBaseData;
    let fieldData;
    let selectedCollection;
    if (completeData) {
      selectedCollection = completeData ? completeData.tables[selectedCollectionIndex] : null;
      fieldData = selectedCollection ? selectedCollection.fields : null;
      Object.keys(fieldData) &&
        Object.keys(fieldData).forEach((fieldName) => {
          if (fieldData[fieldName] === 'integer') {
            fieldData[fieldName] = 'number';
          }
        });
    }
    return fieldData ? (
      <CommonPageComponent>
        <ParentContentCard title={'Collection for Update via Supabase'} icon={'collection'}>
          <Formik
            initialValues={{
              collectionTitle: selectedCollection.collectionTitle || selectedCollection.name,
            }}
            enableReinitialize={true}
          >
            {({ values, handleChange, setFieldValue }) => (
              <Form className="ml-5">
                <div className="col-md-11 col-lg-11 col-sm-12 col-xs-12">
                  <div className="form-group">
                    <FormFieldWithLabel
                      cta={false}
                      label="Collection Name"
                      icon="text"
                      infoIcon={true}
                      infoDescription={'Appwrite collection name'}
                    >
                      <Field
                        type="text"
                        className="form-control form-control-sm"
                        placeholder="Collection Name"
                        readOnly
                        value={selectedCollection.name}
                      />
                    </FormFieldWithLabel>
                  </div>

                  <div className="form-group">
                    <FormFieldWithLabel
                      cta={false}
                      label="Collection Title"
                      icon="text"
                      infoIcon={true}
                      infoDescription={'Enter name for the collection name if  you want to change'}
                      value={values.collectionTitle}
                      onChange={(e) => setFieldValue('collectionTitle', e.target.value)}
                    >
                      <Field
                        type="text"
                        name="collectionTitle"
                        className="form-control form-control-sm"
                        placeholder="Collection Title"
                      />
                      <ErrorMessage name="collectionTitle" component="p" className="text-danger" />
                    </FormFieldWithLabel>
                  </div>
                  <hr style={{ marginBottom: '20px', visibility: 'hidden' }} />
                  {this.showAlertMessage()}
                  <div className="mt-2">
                    <h5>
                      <b>Field Type Mapping</b>
                    </h5>
                  </div>
                  <div
                    className="table-responsive"
                    style={{
                      overflow: 'visible',
                      maxHeight: 'fit-content',
                      marginBottom: '10px',
                    }}
                  >
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th>Fields</th>
                          <th>Types</th>
                          {selectedCollection.selectedPrimaryKey != 'id' && (
                            <th style={{ width: '12%' }}>Primary Key</th>
                          )}
                        </tr>
                      </thead>
                      <tbody>
                        {Object.keys(fieldData).map((fieldName, index) => (
                          <tr key={index}>
                            <td>{fieldName}</td>
                            <td>
                              <CustomSelect
                                name={fieldName}
                                isMulti={false}
                                onChange={setFieldValue}
                                onChangeValue={this.handleFieldChange}
                                options={dropdownsForSupabase}
                                value={getFieldDataTypeValueSupabase(
                                  fieldName,
                                  fieldData,
                                  this.state.fieldDatatypes,
                                )}
                              />
                            </td>
                            {selectedCollection.selectedPrimaryKey !== 'id' && (
                              <td style={{ width: '12%' }}>
                                {selectedCollection.selectedPrimaryKey ? (
                                  <div className="form-check ml-4 pl-3">
                                    <CustomRadio label="" isRadio={false}>
                                      <Field
                                        type="checkbox"
                                        name={fieldName}
                                        className="form-check-input"
                                        checked={
                                          selectedCollection.selectedPrimaryKey === fieldName
                                            ? true
                                            : false
                                        }
                                        disabled={
                                          selectedCollection.selectedPrimaryKey === fieldName
                                            ? false
                                            : true
                                        }
                                      />
                                    </CustomRadio>
                                  </div>
                                ) : (
                                  <div className="form-check ml-4 pl-3">
                                    <CustomRadio label="" isRadio={false}>
                                      <Field
                                        type="checkbox"
                                        name={fieldName}
                                        className="form-check-input"
                                        checked={
                                          selectedCollection.selectedPrimaryKey === fieldName
                                            ? true
                                            : false
                                        }
                                        disabled={
                                          selectedCollection.selectedPrimaryKey === fieldName
                                            ? false
                                            : true
                                        }
                                      />
                                    </CustomRadio>
                                  </div>
                                )}
                              </td>
                            )}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  <div className="d-flex justify-content-between">
                    <button
                      className="btn btn-outline-secondary btn-md"
                      title="Skip"
                      type="button"
                      onClick={this.handleCancel}
                    >
                      <i className="wb webconnect-times"></i> Cancel
                    </button>
                    <button
                      type="button"
                      className="btn btn-theme-submit btn-md"
                      title="Save Collection"
                      onClick={() => this.handleSave(values, selectedCollection.selectedPrimaryKey)}
                      disabled={createCollectionfromSupabasePending}
                    >
                      <i className="wb webconnect-save-regular"></i> Update
                      <CustomLoader loading={createCollectionfromSupabasePending} />
                    </button>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </ParentContentCard>
      </CommonPageComponent>
    ) : (
      <CommonPageComponent>
        <div className="text-center">
          <CustomLoader loading={getSupabaseExternalDbPending} size="20px" color="#303453" />
        </div>
      </CommonPageComponent>
    );
  }
}

function mapStateToProps(state) {
  return {
    dataConnector: state.dataConnector,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SupabaseUpdateCollection);
